import { render } from "./quantidade-dropdown-item.vue?vue&type=template&id=e647a526&scoped=true"
import script from "./quantidade-dropdown-item.vue?vue&type=script&lang=js"
export * from "./quantidade-dropdown-item.vue?vue&type=script&lang=js"

import "./quantidade-dropdown-item.vue?vue&type=style&index=0&id=e647a526&scoped=true&lang=css"

import exportComponent from "C:\\Users\\guilherme.goncalves\\Documents\\FDVSolution\\FDVSolution\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e647a526"]])

export default __exports__